import { color, useLink, getImageColorStyle, isNative } from '@my/util'
import { Button, Image, ImageProps, LinearGradient, LinearGradientProps, Text, XStack, YStack, isWeb } from '@my/ui'
import assets from '../../assets/images/index'
import { Home } from '@tamagui/lucide-icons-2'
import { SidebarStateContext } from '../../provider'
import { ReactElement, useContext, useEffect, useRef, useState } from 'react'

interface FinancialReviewHeadingProps {
  type?: string
  img?: string
  title?: string
  titleLink?: string
  imageStyle?: ImageProps
  gradientStyle?: LinearGradientProps
  dynamicSubtitle?: ReactElement;
}

const whiteFilter = getImageColorStyle(color.white);

const FinancialReviewHeading: React.FC<FinancialReviewHeadingProps> = ({
  type = '',
  img,
  title = '',
  imageStyle,
  gradientStyle,
  titleLink,
  dynamicSubtitle
}) => {
  const homeLinkProps = { ...useLink('/'), hoverStyle: {cursor: 'pointer'}};
  const titleLinkProps = titleLink ? { ...useLink(titleLink), hoverStyle: {cursor: 'pointer'}} : {};
  const sidebarState = useContext(SidebarStateContext);
  const sidebarVisible = sidebarState.isVisible[sidebarState.which];
  const showHomeIcon = !sidebarVisible || isNative
  const dynamicImageStyle = isWeb
  ? { 
    width: 26, height: 26, 
    ...(imageStyle?.['$platform-web'] || {}),
    ...whiteFilter
  }
  : {
    width: 21, height: 21,
    ...(imageStyle?.['$platform-native'] || {}),
    ...whiteFilter
  };
  const mainTitleEle = titleLink ? <XStack style={{flex: 1, flexWrap: 'wrap', gap: 5}}>
    <Text
      fontSize={20}
      $platform-native={{ fontSize: 18 }}
      color={color.darkNavy}
      textAlign="center"
      fontWeight={500}
      style={{textDecoration: 'underline'}}
      {...titleLinkProps}
    >
      {title}
    </Text>
    <Text>{'/'}</Text>
    <Text
      fontSize={20}
      $platform-native={{ fontSize: 18 }}
      color={color.darkNavy}
      textAlign="center"
      fontWeight={700}
    >
      {type}
    </Text>
  </XStack> : <Text
    fontSize={20}
    $platform-native={{ fontSize: 18 }}
    color={color.darkNavy}
    //textAlign="center"
    fontWeight={700}
  >
    {title} {type}
  </Text>
  const titleRegion = dynamicSubtitle ? <YStack flex={1}>
    {mainTitleEle}
    {dynamicSubtitle}
  </YStack> : mainTitleEle;
  return (
    <XStack justifyContent="flex-start" alignItems="center" width="100%" gap={10}>
      {!showHomeIcon ? null : <XStack justifyContent="flex-start" alignItems="center" {...homeLinkProps}>
        <Button unstyled justifyContent='center' alignItems='center' style={{width: 20}} icon={<Home />} />
        <Text>{'/'}</Text>
      </XStack>}
      <LinearGradient
        colors={
          ['rgb(130, 196, 154)', 'rgb(130, 196, 154)']
          //[color.tzaGreen, '#63995D']
        }
        start={[0, 0.3]}
        end={[0, 0]}
        $platform-native={{ width: 41, height: 41 }}
        $platform-web={{ width: 51, height: 51 }}
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: 100,
        }}
        {...gradientStyle}
      >
        <Image
          tintColor={color.white}
          src={img || assets.finacialReviewLogo}
          style={dynamicImageStyle}
        />
      </LinearGradient>
      {titleRegion}
    </XStack>
  )
}

export default FinancialReviewHeading
